import type { Dashboard } from "../model/types";

export const getDashboards = async (): Promise<Dashboard[]> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve([
        {
          id: '1',
          name: 'Dashboard 1',
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
          widgets: [],
        },
      ]);
    }, 2500);
  });
};